import { FC, useEffect, useMemo, useState } from 'react';
import {
  Popup,
  TPopupComponent,
} from '../../../../../../../shared/components/popup/popup.abstract';
import { TPopupDefaultActions } from '../../../../../../../shared/components/popup/services/popup.service';
import { styled } from '@mui/material';
import { Content } from './content.popup';

export class SpecialDatesPopup extends Popup<ISpecialDatesPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;

    this.Component = () => {
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { maxWidth: 445 },
        }));
      }, []);
      const [data, setData] = useState<ISpecialDatesPopup['values'] | undefined>();

      useEffect(() => {
        stream.actionListener('open').subscribe(({ values }) => {
          setData(values);
        });
      }, []);

      return !data ? null : (
        <SWrapper stream={stream} popupTitle={data.description || ''}>
          <Content data={data} stream={stream} />
        </SWrapper>
      );
    };
  }
}

export interface ISpecialDatesPopup {
  action: 'save' | TPopupDefaultActions;
  values: {
    id?: string;
    date?: string;
    replacingDate?: string;
    description?: string;
  };
}
